import {Component, Input, OnInit} from '@angular/core';

import {LibOptionValue} from "daisy-design-system-front";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {FormGroup} from '@angular/forms';
import {DataTimeStepType} from 'swagger-gen/web-secured/models/data-time-step-type';
import {DropdownComponent} from "../../dropdown/dropdown.component";
import {OntologyFormType} from "@gnv-shared/types";
import {NumericInputComponent} from "../../numeric-input/numeric-input.component";

@Component({
    selector: 'app-select-analogic-calculation-interval',
    standalone: true,
    imports: [TranslateModule, DropdownComponent, NumericInputComponent],
    templateUrl: './select-analogic-calculation-interval.component.html',
    styleUrls: ['./select-analogic-calculation-interval.component.scss']
})
export class SelectAnalogicCalculationIntervalComponent implements OnInit {
    @Input() valueFormGroup! : FormGroup<OntologyFormType>;

    public options : LibOptionValue<DataTimeStepType>[] = [];

    constructor(private readonly translate : TranslateService) {
    }

    ngOnInit() : void {
       this.initOptions();
    }

    private initOptions() : void {
      this.options = Object.values(DataTimeStepType)
          .filter(value => value !== DataTimeStepType.SECOND)
          .map(item => {
            return {
              label: this.translate.instant(`stepType.${item}`),
              value: item
            }
          })
    }
}
